import { initializeApi, type ApiMap, type ApiMapKey } from '../../lib';

export const useApi = <T extends ApiMapKey>(name: T) => {
  const apiMap = initializeApi(import.meta.env.VITE_BACKEND_URL);

  return apiMap[name] as InstanceType<ApiMap[T]>;
};
